export default __webpack_public_path__ + "static/media/ic-delete.2047686a.svg";